<template>
    <div v-loading="isloading">
        <Plotchart :chartData="chartdata" :chartType="1" />
        <el-form label-width="160px" label-position="right" :inline="true" size="mini" style="margin-top:20px;">
            <el-form-item label="请选择设备进行查看：" style="margin-bottom:5px;">
                <el-select v-model="eqvalue" placeholder="请选择">
                    <el-option v-for="item in eqoptions"
                               :key="item.Id"
                               :label="item.Code"
                               :value="item.Id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="请选择时间范围：" style="margin-bottom:5px;">
                <el-date-picker v-model="dateRangeValue"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
        </el-form>
            <Datatable ref="dt"  v-if="dtFilterCols.length>0" :tableName="tableName" :tableColumnsOut="dtColsOut" :tableFilterColsParamOut="dtFilterCols" :isShowToolbar="isshowtoolbar" :isShowCheck="isshowcheck" :isShowSort="isshowsort" :isShowFilter="isshowfilter" :isDtFormat="isdtformat" :isDbClick="isdbclick"></Datatable>
    </div>
</template>
    <script>   
        import Plotly from 'plotly.js-dist'
        import { GetLineChart, getListPage } from '@/api/utils';
        import Plotchart from "@/components/Plotchart";
        import Datatable from '@/components/Datatable';

        export default {
            name: 'mainPage',
            components: {
                Plotchart,
                Datatable
            },
            props: {
                tableName: {
                    type: String
                }
            },
            data() {
                return {
                    isloading:true,
                    chartdata: {
                        pdata: [],
                        size: { height: 400 },
                        title: '',
                        chartid:'mainpage'
                    },
                    eqlist:[],
                    eqoptions: [],
                    eqvalue: '',
                    dateRangeValue: ['',''],
                    isshowtoolbar: false,
                    isshowcheck: false,
                    isshowsort: false,
                    isshowfilter: false,
                    isdbclick: false,
                    isdtformat: true,
                    dtFilterCols: [],
                    dtColsOut: [
                        {
                            Id: "16",
                            FormatOption: {
                                type: "array_peaks_mainpage"
                            }
                        }
                    ]
                }
            },
            async created() {
                await this.getequipmentoptions();
                await this.getlinedata(this.eqvalue, '0001-01-01 00:00:00','0001-01-01 00:00:00');
                this.isloading = false;
            },
            mounted() {
            },
            watch: {
                eqvalue: {
                    handler(newVal) {
                        if (newVal) {
                            this.getlinedata(newVal,'0001-01-01 00:00:00', '0001-01-01 00:00:00');
                        }
                    }
                }
            },
            methods: {
                resize() {
                    Plotly.Plots.resize(document.getElementById(this.chartdata.chartid));
                },
                async getequipmentoptions() {
                    let res = await getListPage("Equipment", {});
                    if (res.Data) {
                        this.eqlist = res.Data.list;
                        res.Data.list.forEach(item => {
                            this.eqoptions.push({ Id: item.Id, Code: item.Code });
                        });
                        this.eqvalue = this.eqoptions[0].Id;
                    }
                },
                getchartTitle(eqid) {
                    let eqitem = this.eqlist.find(item => item.Id == eqid);
                    if (eqitem != undefined)
                        return '[' + eqitem.Code + '] ' + eqitem.Address;
                    else return "";
                },
                async getlinedata(equipmentid,starttime,endtime) {
                    var params = {
                        equipmentId: equipmentid,
                        startTime: starttime,
                        endTime: endtime
                    };
                    let res = await GetLineChart(this.tableName,params).catch(() => { });
                    if (res.Data && res.Data != undefined) {
                        this.chartdata.title = this.getchartTitle(equipmentid);
                        this.chartdata.pdata = [];
                        this.chartdata.pdata.push(res.Data.createtime);
                        this.chartdata.pdata.push(res.Data.height);
                        var filtercol = {
                            filters: [{
                                data: res.Data.id
                            }],
                            columnid: 8,
                            columnname: 'Id',
                            tablename: 'Observation'
                        };
                        this.dtFilterCols = [];
                        this.dtFilterCols.push(filtercol);
                        this.$nextTick(() => {
                            this.$refs.dt.getTableData();
                        });
                    }
                },
                onSubmit() {
                    var starttime = this.dateRangeValue[0] == '' ? '0001-01-01 00:00:00' : this.dateRangeValue[0];
                    var endtime = this.dateRangeValue[1] == '' ? '0001-01-01 00:00:00' : this.dateRangeValue[1];
                    this.getlinedata(this.eqvalue, starttime,endtime);
                }
            }
        }
    </script>
    <style scoped>
       
    </style>